{
  "PDF preview": "PDF 预览",
  "Zoom out": "缩小",
  "Zoom in": "放大",
  "Fit width": "适合宽度",
  "Choose valid collection columns without duplicates.": "请选择有效的列表列，且不得重复。",
  "Settings": "设置",
  "Main menu": "主菜单",
  "!CFG": "!CFG",
  "!REV": "!REV",
  ", not": "，而非",
  ". Changing construction class requires a different identity.": "。更改结构类型需要另一个标识。",
  ". It is shown only once.": "。仅显示一次。",
  ". Where-used follows the actual structure—not the numbering path.": "。使用位置由实际结构决定，而非编号路径。",
  "? The history remains.": "？历史记录将保留。",
  "? The original part remains in the registry.": "？原零件仍保留在登记库中。",
  "A PIN needs a project/product version and at least one identity node (maximum depth 32).": "PIN 必须包含项目、产品版本及至少一个标识节点，最大深度为 32。",
  "A change is awaiting confirmation": "更改等待确认",
  "A controlled construction-class change requires another identity. Issue the new part rather than renaming this one.": "受控结构更改类型时需创建新零件，不能重命名现有零件。",
  "A new link will replace the previous invitation link for": "新链接将替换以下用户的旧邀请链接：",
  "A part cannot replace itself.": "零件不能替代自身。",
  "A piece part cannot have a configuration.": "单件零件不能具有配置。",
  "A piece part cannot have controlled children.": "单件零件不能包含受控子项。",
  "A piece part cannot retain controlled children.": "单件零件不能保留受控子项。",
  "A qualified reference must select a released revision.": "限定引用必须选择已发布的修订版。",
  "A verified Google email is required.": "需要经过 Google 验证的电子邮件地址。",
  "ALPHA": "ALPHA",
  "About {value0}": "关于 {value0}",
  "Accept company invitation": "接受公司邀请",
  "Account": "账户",
  "Account and company settings": "账户与公司设置",
  "Active": "启用",
  "Active assembly": "当前装配体",
  "Add alias": "添加外部编号",
  "Add code": "添加代码",
  "Add directional replacement": "添加单向替代关系",
  "Add part": "添加零件",
  "Add replacement": "添加替代关系",
  "Add to {value0}": "添加到 {value0}",
  "Adding…": "正在添加…",
  "Alias notes": "外部编号备注",
  "Alias organization": "外部编号所属组织",
  "Alias type": "外部编号类型",
  "All alias types": "所有外部编号类型",
  "All companies": "所有公司",
  "All selected child revisions must be released.": "所有选定的子项修订版必须已发布。",
  "All states": "所有状态",
  "All types": "所有类型",
  "Aluminium": "铝",
  "An assembly needs at least one controlled child before release.": "装配体发布前必须至少包含一个受控子项。",
  "An example drawing change tightens a tolerance.": "示例中的图纸更改收紧了公差。",
  "An external alias cannot impersonate another canonical part number.": "外部编号不能冒用另一零件的规范编号。",
  "An identifier or historical alias already occupies the requested number.": "该编号已被标识或历史别名占用。",
  "An independently orderable configured product needs its own assembly P/N.": "可独立订购的配置产品需要自己的装配体编号。",
  "An invitation is already pending. Replace its link instead.": "已有待处理邀请，请替换其链接。",
  "An occurrence cannot be moved to another owner by editing it.": "不能通过编辑将使用项移至另一个所属结构。",
  "Another change was being saved. Retry this same request.": "正在保存另一项更改，请重试同一请求。",
  "Another owner must accept membership before removing the last owner.": "移除最后一位所有者前，另一位所有者必须先接受邀请。",
  "Another project": "其他项目",
  "Apply filters": "应用筛选",
  "Arm": "机械臂",
  "Arm assembly": "机械臂装配体",
  "As authored": "按原始单位",
  "Ask a company owner to register a new code.": "请公司所有者注册新代码。",
  "Assembly": "装配体",
  "Assembly configurations": "装配体配置",
  "Assignment correction": "分配更正",
  "Back to blueprint": "返回蓝图",
  "Before controlled dependencies exist, correct the assignment with an audit entry. No old-number redirect is kept.": "建立受控依赖前，可更正分配并记录审计。旧编号不会保留重定向。",
  "Best match": "最佳匹配",
  "Bonded": "粘接",
  "Bonded assembly": "粘接装配体",
  "Bonded grip": "粘接握把",
  "Both leaders point to the same P/N.": "两条引线指向相同的零件编号。",
  "CF": "CF",
  "Cancel": "取消",
  "Cancel {value0} edit": "取消编辑 {value0}",
  "Carbon fibre": "碳纤维",
  "Change {value0}'s role": "更改 {value0} 的角色",
  "Check result": "检查结果",
  "Choose Active, Obsolete or Retired.": "请选择有效、过时或停用。",
  "Choose Owner, Editor or Viewer.": "请选择所有者、编辑者或查看者。",
  "Choose P, A, W, G or R.": "请选择 P、A、W、G 或 R。",
  "Choose a company": "选择公司",
  "Choose a measurement unit preference.": "请选择计量单位偏好。",
  "Choose a part and exact revision from this company.": "请选择本公司的零件及确切修订版。",
  "Choose a product version from the default project.": "请选择默认项目中的产品版本。",
  "Choose a standard position or register its code in this company.": "请选择标准位置，或在本公司注册其代码。",
  "Choose a supplier, manufacturer or customer alias.": "请选择供应商、制造商或客户编号。",
  "Choose a supported interface language.": "请选择支持的界面语言。",
  "Choose a supported regional format.": "请选择支持的区域格式。",
  "Choose a table density.": "请选择表格密度。",
  "Choose a valid alias type.": "请选择有效的外部编号类型。",
  "Choose a valid part state.": "请选择有效的零件状态。",
  "Choose a valid part type.": "请选择有效的零件类型。",
  "Choose a valid results page and page size.": "请选择有效的结果页码及每页数量。",
  "Choose a valid search order.": "请选择有效的排序方式。",
  "Choose a valid time zone.": "请选择有效的时区。",
  "Choose an assembly parent in the selected product version.": "请选择此产品版本中的上级装配体。",
  "Choose an assembly parent outside this identity's descendant graph, in the selected product version.": "请选择此产品版本中不属于该标识后代的上级装配体。",
  "Choose an editable assembly and an exact part revision.": "请选择可编辑的装配体及确切零件修订版。",
  "Choose each time": "每次选择",
  "Choose exactly one structure owner.": "请选择且仅选择一个所属结构。",
  "Choose its revision and quantity to add it to this assembly.": "请选择修订版和数量以添加到此装配体。",
  "Choose one structure owner.": "请选择一个所属结构。",
  "Choose the default company first.": "请先选择默认公司。",
  "Choose the part that can replace this one.": "请选择能够替代此零件的零件。",
  "Class": "类别",
  "Clear filters": "清除筛选",
  "Close": "关闭",
  "Close reuse parts": "关闭零件复用",
  "Close {value0}": "关闭 {value0}",
  "Code": "代码",
  "Comfortable": "舒适",
  "Compact": "紧凑",
  "Companies": "公司",
  "Company": "公司",
  "Company code": "公司代码",
  "Company name": "公司名称",
  "Company not found.": "未找到公司。",
  "Company parts": "公司零件",
  "Company settings": "公司设置",
  "Company-wide role": "公司级角色",
  "Configuration": "配置",
  "Configuration name": "配置名称",
  "Configurations": "配置",
  "Configurations apply to assemblies, not piece parts.": "配置适用于装配体，而非单件零件。",
  "Construction classes": "结构类型",
  "Copy a revision of this part.": "复制此零件的修订版。",
  "Correct engineering identity": "更正工程标识",
  "Corrected text": "更正后的文本",
  "Correction & replacement": "更正与替代",
  "Correction reason": "更正原因",
  "Cover": "盖板",
  "Cover numbered beneath it": "在其下编号的盖板",
  "Cover revisions": "盖板修订版",
  "Cover · 1 each · forearm": "盖板 · 1 件 · 前臂",
  "Create company": "创建公司",
  "Create configuration": "创建配置",
  "Create invitation": "创建邀请",
  "Create project": "创建项目",
  "Create variant": "创建变体",
  "Create version": "创建版本",
  "Current structure": "当前结构",
  "Default quantity unit": "默认数量单位",
  "Default workspace": "默认工作区",
  "Description": "说明",
  "Details": "详情",
  "Different identity": "不同标识",
  "Directional replacements": "单向替代关系",
  "Draft": "草稿",
  "Drawing unavailable. Part-number examples remain interactive.": "图纸不可用，零件编号示例仍可交互。",
  "ER": "ER",
  "Edit company": "编辑公司",
  "Edit configuration": "编辑配置",
  "Edit details": "编辑详情",
  "Edit part details": "编辑零件详情",
  "Edit part use": "编辑零件使用项",
  "Edit product version": "编辑产品版本",
  "Edit project": "编辑项目",
  "Editor": "编辑者",
  "Engineering": "工程",
  "Engineering Registry": "工程注册库",
  "Enter a canonical PIN.": "请输入规范 PIN。",
  "Enter a position code.": "请输入位置代码。",
  "Enter a positive quantity and a unit.": "请输入正数量和单位。",
  "Enter a valid email address.": "请输入有效的邮箱地址。",
  "Enter a variant code.": "请输入变体代码。",
  "Exact child revision": "确切子项修订版",
  "Exact children in this baseline": "此基线中的确切子项",
  "Existing codes…": "现有代码…",
  "Existing hand, used in V": "已有机械手，用于 V",
  "Existing part": "现有零件",
  "Explain": "解释",
  "External aliases": "外部编号",
  "External part number": "外部零件编号",
  "Filters": "筛选",
  "Find an existing part": "查找现有零件",
  "Find parts": "查找零件",
  "Find {value0}": "查找 {value0}",
  "For an unrelated part, leave Related part empty to allocate a new number.": "新零件若无关联，请留空关联零件字段以分配新编号。",
  "Forearm cover": "前臂盖板",
  "Front view · left/right is the robot’s own left/right": "正视图 · 左右以机器人自身为准",
  "Front view. The robot’s right hand is on the left of the drawing; its left hand is on the right.": "正视图。机器人的右手位于图中左侧，左手位于图中右侧。",
  "Google account email": "Google 账户邮箱",
  "Google could not verify this sign-in. Try again.": "Google 无法验证此次登录，请重试。",
  "Google sign-in could not load. Check your connection and try again.": "无法加载 Google 登录，请检查网络后重试。",
  "Google sign-in is not configured.": "尚未配置 Google 登录。",
  "Hand identities": "机械手标识",
  "Head casing": "头部外壳",
  "Hide": "隐藏",
  "Historical rename": "保留历史的重命名",
  "History": "历史",
  "Hole Ø6 mm · tolerance ±": "孔 Ø6 mm · 公差 ±",
  "Identity family": "标识系列",
  "Identity history examples": "标识历史示例",
  "Illustrative example · not your registry": "示例说明 · 非您的登记库",
  "Imperial": "英制",
  "Interactive robot part numbers": "交互式机器人零件编号",
  "Invitation link": "邀请链接",
  "Invitation not found.": "未找到邀请。",
  "Invite person": "邀请人员",
  "Issue part number": "分配零件编号",
  "Issue variant": "创建变体编号",
  "Issuing the cover beneath it appends": "在其下编号的盖板会追加",
  "It does not tell you where it is used now.": "这并不表示当前使用位置。",
  "Keep the part number and name columns; each column may appear only once.": "请保留编号和名称列；每列只能出现一次。",
  "Knee pin ×2": "膝部销轴 ×2",
  "Language": "语言",
  "Left / right": "左 / 右",
  "Left hand": "左手",
  "Left hand · 1 each · wrist": "左手 · 1 件 · 腕部",
  "Loading…": "正在加载…",
  "Main navigation": "主导航",
  "Material": "材料",
  "Meaning": "含义",
  "Measurement units": "测量单位",
  "Members": "成员",
  "Metric": "公制",
  "Move {column} down": "将 {column} 下移",
  "Move {column} up": "将 {column} 上移",
  "Name": "名称",
  "Navigation": "导航",
  "Neither family membership nor a variant code promises interchangeability.": "系列归属和变体代码均不保证互换性。",
  "New assembly": "新装配",
  "New camera in V2": "V2 中的新相机",
  "New camera, first numbered in V2": "新相机，首次在 V2 中编号",
  "New codes are registered by a company owner.": "新代码由公司所有者注册。",
  "New company": "新建公司",
  "New configuration": "新建配置",
  "New part": "新零件",
  "New product version": "新建产品版本",
  "New project": "新建项目",
  "New revision": "新建修订版",
  "New version": "新建版本",
  "No choices available.": "没有可用选项。",
  "No parts yet.": "暂无零件。",
  "No selected occurrences.": "未选择使用项。",
  "None": "无",
  "Not confirmed yet. Retry the saved change to resolve it safely.": "尚未确认。重试已保存的更改以安全确认结果。",
  "Not found.": "未找到。",
  "Notes": "备注",
  "Numbering beneath an assembly does not place the cover in its structure. Adding an occurrence is separate; reuse elsewhere keeps this P/N.": "在装配体下编号并不会将盖板加入其结构。添加使用项需另行操作；在别处复用仍保留此编号。",
  "Numbering concept": "编号概念",
  "Numbering path": "编号路径",
  "Obsolete": "过时",
  "Old text": "旧文本",
  "Only !REV changes.": "仅 !REV 发生变化。",
  "Only company owners can manage membership.": "只有公司所有者可以管理成员。",
  "Only the configured administrator can create companies.": "只有指定管理员可以创建公司。",
  "Open PIN": "打开 PIN",
  "Open navigation": "打开导航",
  "Open project explorer": "打开项目树",
  "Organization": "组织",
  "Original identity": "原始标识",
  "Overview": "概览",
  "Owner": "所有者",
  "P/N prefix": "编号前缀",
  "P/N preview": "编号预览",
  "Page not found": "未找到页面",
  "Part": "零件",
  "Part name": "零件名称",
  "Part number": "零件编号",
  "Part number preview": "零件编号预览",
  "Part number ↑": "零件编号 ↑",
  "Part number ↓": "零件编号 ↓",
  "Part number, name, material or alias": "编号、名称、材料或外部编号",
  "Part numbering guide": "零件编号指南",
  "Part prefixes change together; controlled historical identifiers keep redirects.": "零件前缀一并更改；受控历史编号保留重定向。",
  "Part record": "零件记录",
  "Part section": "零件章节",
  "Part type": "零件类型",
  "Parts": "零件",
  "Parts first numbered in this product version.": "首次在此产品版本中编号的零件。",
  "Per page": "每页",
  "Personal preferences": "个人偏好",
  "Piece": "单件",
  "Piece part": "单件零件",
  "Piece parts cannot have controlled children.": "单件零件不能包含受控子项。",
  "Piece parts do not have assembly configurations.": "单件零件没有装配体配置。",
  "Position": "位置",
  "Position code": "位置代码",
  "Position codes contain 1–12 uppercase letters.": "位置代码由 1–12 个大写英文字母组成。",
  "Product shown": "显示的产品",
  "Product version": "产品版本",
  "Product versions": "产品版本",
  "Project": "项目",
  "Project / product version": "项目 / 产品版本",
  "Project code": "项目代码",
  "Project explorer": "项目树",
  "Project name": "项目名称",
  "Project settings": "项目设置",
  "Project workspace": "项目工作区",
  "Projects": "项目",
  "Quantity": "数量",
  "Quantity and position belong to each occurrence, not to the part’s identity. Both knees select revision 1.": "数量和位置属于每个使用项，而非零件标识。两侧膝部均选择修订版 1。",
  "Quantity must be positive, at most one billion, with no more than six decimal places.": "数量必须为正数，不超过十亿，最多六位小数。",
  "ROBOT project": "ROBOT 项目",
  "Reason for changing the code": "更改代码的原因",
  "Reason for correcting the code": "更正代码的原因",
  "Reason for correcting version number": "更正版本号的原因",
  "Regional format": "区域格式",
  "Register code": "注册代码",
  "Register variant code": "注册变体代码",
  "Registered meanings cannot be reassigned after use.": "代码使用后不能重新指定其含义。",
  "Registered {value0} codes": "已注册的 {value0} 代码",
  "Registry": "登记库",
  "Related identities are not automatically interchangeable.": "关联标识并不自动意味着可互换。",
  "Related part": "关联零件",
  "Release configuration": "发布配置",
  "Release each selected child revision before releasing this assembly.": "请先发布所有选定子项修订版，再发布此装配体。",
  "Release the assembly revision before releasing this configuration.": "请先发布装配体修订版，再发布此配置。",
  "Released": "已发布",
  "Released arm baseline": "已发布的机械臂基线",
  "Released configurations cannot be changed. Create a new configuration.": "已发布的配置不能更改，请创建新配置。",
  "Released definitions stay unchanged. Create a new revision to make changes.": "已发布的定义保持不变。修改时请创建新修订版。",
  "Released structures stay unchanged. Create a new revision.": "已发布的结构保持不变，请创建新修订版。",
  "Reload saved preferences": "重新加载已保存的偏好",
  "Reload structure": "重新加载结构",
  "Remove": "移除",
  "Remove access": "移除访问权限",
  "Remove alias": "移除外部编号",
  "Remove external alias?": "移除外部编号？",
  "Remove from assembly": "从装配体中移除",
  "Remove from assembly?": "从装配体中移除？",
  "Remove saved search": "删除已保存的搜索",
  "Remove saved search?": "删除已保存的搜索？",
  "Remove {value0}'s access?": "移除 {value0} 的访问权限？",
  "Replace invitation link?": "替换邀请链接？",
  "Replace link": "替换链接",
  "Replacement": "替代",
  "Replacement conditions": "替代条件",
  "Results per page": "每页结果数",
  "Retired": "已停用",
  "Retry saved change": "重试已保存的更改",
  "Reuse & structure": "复用与结构",
  "Reuse parts": "复用零件",
  "Reuse source": "复用来源",
  "Rev": "修订",
  "Revision": "修订",
  "Revision and configuration numbers must be positive.": "修订版和配置编号必须为正数。",
  "Revision structures are selected by revision, not by project snapshot.": "结构按修订版选择，而非按项目快照选择。",
  "Revisions": "修订版",
  "Revoke invitation": "撤销邀请",
  "Revoke invitation?": "撤销邀请？",
  "Right hand": "右手",
  "Riveted": "铆接",
  "Riveted assembly": "铆接装配体",
  "Riveted chest panel": "铆接胸板",
  "Robot numbering guide": "机器人编号指南",
  "Same assembly and revision, different frozen selections.": "相同装配体和修订版，不同的冻结选项。",
  "Same cover identity": "相同盖板标识",
  "Save": "保存",
  "Save as a new search": "另存为新搜索",
  "Save changes": "保存更改",
  "Save configuration": "保存配置",
  "Save project": "保存项目",
  "Save replacement": "保存替代关系",
  "Save search": "保存搜索",
  "Saved change recovery": "恢复已保存的更改",
  "Saved searches": "已保存的搜索",
  "Saving…": "正在保存…",
  "Search": "搜索",
  "Search columns and order": "搜索列及顺序",
  "Search company parts": "搜索公司零件",
  "Search filters": "搜索筛选",
  "Search name": "搜索名称",
  "Search order": "搜索排序",
  "Search part numbers or names": "搜索零件编号或名称",
  "Searching…": "正在搜索…",
  "Search…": "搜索…",
  "Select a cover to see its P/N on the robot. Geometry can look alike while material and engineering definition differ.": "选择盖板可在机器人上查看其编号。外形相似，材料和工程定义仍可能不同。",
  "Select a revision of this assembly.": "请选择此装配体的修订版。",
  "Select a variant code registered in this company.": "请选择本公司已注册的变体代码。",
  "Select an assembly revision.": "请选择装配体修订版。",
  "Select an exact child revision.": "请选择确切的子项修订版。",
  "Select at least one child occurrence before releasing an assembly configuration.": "发布装配体配置前，至少选择一个子项使用项。",
  "Selected engineering definition": "选定的工程定义",
  "Selected revision": "选定修订版",
  "Send this link to": "将此链接发送给",
  "Separable": "可分离",
  "Separable assembly": "可拆装配体",
  "Several parts use this external alias. Search it and choose the correct part.": "多个零件使用此外部编号。请搜索并选择正确的零件。",
  "Show V": "显示 V",
  "Show all company parts": "显示公司全部零件",
  "Show {column}": "显示 {column}",
  "Showing the first": "显示前",
  "Shown in product version V": "显示于产品版本 V",
  "Sign in first.": "请先登录。",
  "Sign in to continue.": "请登录以继续。",
  "Sign in to your engineering workspace.": "登录您的工程工作区。",
  "Sign in with the Google account named on this invitation.": "请使用邀请中指定的 Google 账户登录。",
  "Sign out": "退出登录",
  "Signing in…": "正在登录…",
  "Skip to content": "跳至内容",
  "Sort": "排序",
  "Standard position meanings cannot be changed.": "不能更改标准位置的含义。",
  "State": "状态",
  "Structure": "结构",
  "Structure snapshot": "结构快照",
  "Structure snapshot not found.": "未找到结构快照。",
  "Switch to V2: the reused hands and knee pins keep their V1 numbers. Only the new camera receives a V2 number. ROBOT is the project code; V1/V2 are product versions, not part revisions.": "切换到 V2：复用的机械手和膝部销轴保留 V1 编号。只有新相机获得 V2 编号。ROBOT 是项目代码；V1/V2 是产品版本，并非零件修订版。",
  "Switch to {value0} appearance": "切换为{value0}主题",
  "Table density": "表格密度",
  "That record was not found in this company.": "在此公司中未找到该记录。",
  "The corrected identifier must differ from the current identifier.": "更正后的标识必须不同于当前标识。",
  "The correction creates duplicate identifiers.": "此更正会产生重复标识。",
  "The identifier number is outside the supported positive integer range.": "标识中的数字超出了支持的正整数范围。",
  "The next number changed. Review the updated preview, then issue again.": "下一个编号已更改。请检查更新后的预览并再次分配。",
  "The number is allocated within its prefix:": "编号在此前缀内分配：",
  "The old item remains its own record. Example condition: the replacement cover fits only with an adapter. The reverse is not implied; replacement is not an alias.": "旧零件仍保留独立记录。条件示例：替代盖板仅在使用适配器时适用。不意味着可反向替代；替代关系不是别名。",
  "The old released definition remains available; an unqualified P/N identifies the item, not “latest revision”.": "旧的已发布定义仍可访问；无限定符的编号标识零件，而非“最新修订版”。",
  "The part is saved in the company registry.": "零件已保存在公司登记库中。",
  "The pending invitation for": "待处理邀请，收件人：",
  "The prefix is ROBOT-V1.2A.": "前缀为 ROBOT-V1.2A。",
  "The related family must have the same product version and origin parent.": "关联系列必须具有相同产品版本和原始上级。",
  "The request could not be completed. Retry or reload; confirm any pending change before editing again.": "无法完成请求。请重试或重新加载；再次编辑前先确认待处理更改。",
  "The request could not be read. Check your input and try again.": "无法读取请求，请检查输入后重试。",
  "The revision and configuration select different assembly baselines.": "修订版和配置选择了不同的装配体基线。",
  "The same forearm cover shape in silver aluminium on the left and woven carbon fibre on the right": "相同形状的前臂盖板：左侧为银色铝材，右侧为编织碳纤维",
  "The selected part may replace": "选定零件可替代",
  "They share a family number, not an interchangeable identity. “Not sided” omits the qualifier; issuing one side does not issue the other.": "共享系列编号并不意味着可互换。“无侧别”不加限定符；创建一侧不会同时创建另一侧。",
  "This PIN was not found in the selected company.": "在选定公司中未找到此 PIN。",
  "This baseline uses multiple revisions of the child. Specify !REV explicitly.": "此基线使用该子项的多个修订版，请明确指定 !REV。",
  "This change conflicts with an existing record. Reload and review your changes.": "此更改与现有记录冲突，请重新加载并检查更改。",
  "This child revision is not in the selected parent baseline.": "此子项修订版不在所选上级基线中。",
  "This code was registered elsewhere. Review its meaning before using it.": "此代码已在其他会话注册，请先检查其含义。",
  "This configuration is already released.": "此配置已发布。",
  "This destination is read-only or the revision is unavailable.": "目标为只读或修订版不可用。",
  "This family number belongs to another family. Issue a related identity explicitly instead.": "此编号属于另一系列，请明确创建关联标识。",
  "This identifier is reserved by a historical rename.": "此标识已被历史重命名保留。",
  "This invitation has expired or been revoked.": "邀请已过期或撤销。",
  "This invitation has expired, was replaced, or is no longer pending.": "邀请已过期、已替换或不再待处理。",
  "This invitation is no longer pending.": "此邀请不再处于待处理状态。",
  "This is the next available number, not a reservation. The number is checked again when you issue. If another person takes it first, the form stays open with an updated preview.": "这是下一个可用编号，并未预留。分配时会再次检查；若已被他人占用，表单保持打开并更新预览。",
  "This occurrence would create a structure cycle.": "此使用项会导致结构循环。",
  "This part number already exists. Choose a different variant or position.": "此编号已存在，请选择其他变体或位置。",
  "This person is already a member. Change their role in Members.": "此人已是成员，请在成员管理中更改角色。",
  "This product version number is already assigned.": "此产品版本号已分配。",
  "This project code already exists.": "此项目代码已存在。",
  "This record changed. Reload it before saving again.": "记录已更改，请重新加载后再保存。",
  "This released configuration does not exist.": "此已发布配置不存在。",
  "This replacement direction already exists.": "此替代方向已存在。",
  "This revision does not exist.": "此修订版不存在。",
  "This revision is already released.": "此修订版已发布。",
  "This saved search belongs to another person.": "此已保存搜索属于其他人。",
  "This updates the project's part-number prefixes. Controlled identities retain historical redirects.": "这会更新项目的编号前缀，受控标识保留历史重定向。",
  "Time zone": "时区",
  "Try again": "重试",
  "Two hands, two identities.": "两只手，两个标识。",
  "Two occurrences, one part": "两个使用项，同一个零件",
  "Unit": "单位",
  "Unsaved search": "未保存的搜索",
  "Use PROJECT-V1 followed by unpadded identity nodes.": "请使用 PROJECT-V1，后接无前导零的标识节点。",
  "Use a positive product version number.": "请使用正数产品版本号。",
  "Use a positive, unpadded family number.": "请使用无前导零的正数系列编号。",
  "Use a whole number for the search filter.": "搜索筛选中请使用整数。",
  "Use an uppercase code starting with a letter, containing letters, numbers or hyphens (maximum 32 characters).": "代码必须以大写英文字母开头，仅含大写字母、数字或连字符，最多 32 个字符。",
  "Use code": "使用代码",
  "Use number/class, optional !VARIANT and #POSITION, then !REV and !CFG in that order. Leading zeroes and colon qualifiers are not valid.": "使用数字/类型，可选 !VARIANT 和 #POSITION，然后依次为 !REV 和 !CFG。不允许前导零或冒号限定符。",
  "Using this pin in V2 or another project in the same company keeps": "在 V2 或同公司其他项目中使用此销轴会保留",
  "V1 tells you where a part was first numbered.": "V1 表示零件首次编号的产品版本。",
  "Variant code": "变体代码",
  "Variant codes": "变体代码",
  "Variant codes contain uppercase letters and cannot start with REV or CFG.": "变体代码包含大写英文字母，不能以 REV 或 CFG 开头。",
  "Variants & replacements": "变体与替代",
  "Version name": "版本名称",
  "Version name (optional)": "版本名称（可选）",
  "Version number": "版本号",
  "View parts": "查看零件",
  "Viewer": "查看者",
  "Wait for a valid part-number preview.": "请等待有效的零件编号预览。",
  "Welded": "焊接",
  "Welded assembly": "焊接装配体",
  "Welded torso frame": "焊接躯干框架",
  "Where used": "使用位置",
  "With controlled dependencies, old text redirects to the renamed item. !REV1 still resolves that exact historical revision; configurations and descendant numbering are preserved.": "存在受控依赖时，旧文本重定向至重命名后的零件。!REV1 仍解析到确切历史修订版；配置和后代编号保持不变。",
  "Withdraw permission for": "撤回以下零件的替代许可：",
  "Withdraw replacement": "撤回替代关系",
  "Withdraw replacement?": "撤回替代关系？",
  "You are already a member of this company.": "您已是此公司的成员。",
  "Your form session expired. Refresh your session, then retry the saved change.": "表单会话已过期，请刷新会话后重试已保存的更改。",
  "Your preferences changed. Reload before saving again.": "您的偏好已更改，请重新加载后保存。",
  "across this company": "在整个公司内",
  "and": "和",
  "at {value0}": "位于 {value0}",
  "dark": "深色",
  "distinguish the right-hand and left-hand forms. The two connected labels point to the robot’s own hands, not the viewer’s sides.": "区分右侧与左侧形态。引线指向机器人的自身左右手，而非观察者的左右侧。",
  "from": "从",
  "from this structure? The original part remains in the company registry.": "从此结构中移除？原零件仍保留在公司登记库中。",
  "in this example.": "在此示例中。",
  "is the construction class, not a revision. P is a single piece without controlled children; A, W, G and R are assemblies joined in different ways.": "表示结构类型，而非修订版。P 是无受控子项的单件；A、W、G、R 是采用不同连接方式的装配体。",
  "issued.": "已分配。",
  "light": "浅色",
  "match": "匹配项",
  "matches": "匹配项",
  "mm": "mm",
  "of": "的",
  "only under the stated conditions.": "仅在指定条件下。",
  "parts. Search the company to find additional matches.": "个零件。搜索公司以查找更多匹配项。",
  "to replace": "以替代",
  "will lose access to every project and part in this company.": "将失去对此公司所有项目及零件的访问权限。",
  "will no longer work.": "将不再有效。",
  "{field} must contain {minimum}–{maximum} characters.": "{field}必须包含 {minimum}–{maximum} 个字符。",
  "{value0} added to {value1}.": "已将 {value0} 添加到 {value1}。",
  "{value0} code": "{value0} 代码",
  "{value0} cover example": "{value0} 盖板示例",
  "{value0} editor": "{value0} 编辑器",
  "{value0} meaning": "{value0} 含义",
  "{value0} · Rev {value1}": "{value0} · 修订 {value1}",
  "{value0}!REV1": "{value0}!REV1",
  "{value0}!REV{value1}": "{value0}!REV{value1}",
  "· 1 each": "· 各 1 件",
  "· Refine your search for other matches.": "· 请细化搜索以查找其他匹配项。",
  "· Revision {value0}": "· 修订 {value0}",
  "!CF": "!CF",
  "!CF changes the identity, not its revision.": "!CF 更改标识，而非修订版。",
  "!CFG{value0}": "!CFG{value0}",
  "!REV1": "!REV1",
  "!REV{value0}": "!REV{value0}",
  "? Its definition and exact child occurrences become immutable. Further changes require a new revision.": "？其定义及确切子项使用将不可更改。后续更改需要新修订版。",
  "Accept invitation": "接受邀请",
  "Accepting…": "正在接受…",
  "Actions": "操作",
  "Actions for {value0}": "{value0} 的操作",
  "Add description": "添加描述",
  "Add external alias": "添加外部编号",
  "An origin parent is selected.": "已选择原始上级。",
  "Applicability / effectivity": "适用范围 / 生效条件",
  "Apply identity correction": "应用标识更正",
  "Assembly revision": "装配体修订版",
  "Both covers share": "两块盖板共享",
  "Change role": "更改角色",
  "Checking number…": "正在检查编号…",
  "Child REV": "子项修订",
  "Choose a project": "选择项目",
  "Choose a revision to inspect its exact definition.": "请选择修订版以查看其确切定义。",
  "Choose a revision to view its exact structure.": "请选择修订版以查看其确切结构。",
  "Choose an assembly in the selected product version.": "请选择此产品版本中的装配体。",
  "Choose an exact assembly revision.": "请选择确切的装配体修订版。",
  "Choose another company": "选择其他公司",
  "Collapse": "折叠",
  "Company access unavailable": "无法访问公司",
  "Copied.": "已复制。",
  "Copy link": "复制链接",
  "Copy was unavailable. Select the link and copy it manually.": "无法复制，请选择链接并手动复制。",
  "Correct identity": "更正标识",
  "Custom position…": "自定义位置…",
  "Definition": "定义",
  "Details for {value0}": "{value0} 的详情",
  "Edit": "编辑",
  "Edit alias {value}": "编辑外部编号 {value}",
  "Edit definition": "编辑定义",
  "Edit external alias": "编辑外部编号",
  "Empty definition": "空定义",
  "Expand": "展开",
  "Family number": "系列编号",
  "Freeze CFG": "冻结 CFG",
  "Google sign-in is not configured. The administrator needs to restore the sign-in configuration.": "尚未配置 Google 登录。管理员需要恢复登录配置。",
  "Identity": "标识",
  "In this example company, CF is registered as “carbon fibre”. Other companies may register different meanings.": "示例公司将 CF 注册为“碳纤维”。其他公司可注册不同含义。",
  "Include selected revision": "包含选定修订版",
  "Invitations": "邀请",
  "Join": "连接",
  "Left": "左",
  "Next": "下一页",
  "No child parts.": "没有子零件。",
  "No companies yet.": "暂无公司。",
  "No configurations yet.": "暂无配置。",
  "No external aliases.": "没有外部编号。",
  "No invitations.": "没有邀请。",
  "No matching choices.": "没有匹配选项。",
  "No matching parts.": "没有匹配零件。",
  "No parts in this structure yet.": "此结构中暂无零件。",
  "No product versions in this project.": "此项目中没有产品版本。",
  "No product versions yet.": "暂无产品版本。",
  "No projects yet.": "暂无项目。",
  "No replacement relationships.": "没有替代关系。",
  "No variant code": "无变体代码",
  "No variant codes registered.": "尚未注册变体代码。",
  "Not reserved": "未预留",
  "Numbered directly under the product version.": "直接在产品版本下编号。",
  "Open assembly {value0}": "打开装配体 {value0}",
  "Open resolved configuration": "打开解析到的配置",
  "Origin product version": "原始产品版本",
  "Other positions": "其他位置",
  "Other positions add a distinct identity qualifier: #N/#S, #W/#E, #FRONT/#MIDLONG/#REAR, and #TOP/#MIDVERT/#BOTTOM. The two Mid choices belong to different axes. Custom codes have a company-defined meaning. This is not the location or position number of a reused part in an assembly.": "其他位置添加不同的标识限定符：#N/#S、#W/#E、#FRONT/#MIDLONG/#REAR 和 #TOP/#MIDVERT/#BOTTOM。两个“中部”属于不同轴线。自定义代码的含义由公司定义。这不是复用零件在装配体中的安装位置或位号。",
  "Other positions…": "其他位置…",
  "Page {page} of {pages}": "第 {page} 页，共 {pages} 页",
  "Part / P/N": "零件 / 编号",
  "Part section not found.": "未找到零件章节。",
  "Parts in {value0}": "{value0} 中的零件",
  "Person": "人员",
  "Piece parts have no child structure.": "单件零件没有子结构。",
  "Position for occurrence {value0}": "使用项 {value0} 的位置",
  "Previous": "上一页",
  "Product root": "产品根节点",
  "Product structure": "产品结构",
  "Qty": "数量",
  "Quantity for occurrence {value0}": "使用项 {value0} 的数量",
  "Quantity for {value0} {value1}": "{value0} {value1} 的数量",
  "Quantity saved for {value0}.": "已保存 {value0} 的数量。",
  "Read-only access": "只读权限",
  "Reason for correction": "更正原因",
  "Registered variant": "已注册变体",
  "Release": "发布",
  "Release revision": "发布修订版",
  "Remove alias {value}": "移除外部编号 {value}",
  "Remove from assembly {value0} {value1}": "从装配体移除 {value0} {value1}",
  "Remove selected occurrence": "移除选定使用项",
  "Remove {value0}'s access": "移除 {value0} 的访问权限",
  "Replace invitation link for {value0}": "替换 {value0} 的邀请链接",
  "Reset quantity for {value0}": "重置 {value0} 的数量",
  "Resolved definition: REV": "解析到的定义：REV",
  "Results: {count}": "结果：{count}",
  "Retry preview": "重试预览",
  "Revoke": "撤销",
  "Revoke invitation for {value0}": "撤销 {value0} 的邀请",
  "Right": "右",
  "Role": "角色",
  "Same family number, different identities.": "相同系列编号，不同标识。",
  "Save quantity for {value0}": "保存 {value0} 的数量",
  "Search pages": "搜索分页",
  "Source product version": "来源产品版本",
  "Source project": "来源项目",
  "Start from": "起始于",
  "Structural class": "结构类型",
  "The invitation was created, but its one-time link cannot be shown again. Use Replace link to generate another.": "邀请已创建，但一次性链接无法再次显示。请使用“替换链接”生成新链接。",
  "This invitation link is incomplete. Ask the company owner for a replacement link.": "邀请链接不完整，请向公司所有者索取替换链接。",
  "This part is not used in a structure or configuration.": "此零件未用于任何结构或配置。",
  "This structure is read-only. Choose a draft revision to edit.": "此结构为只读，请选择草稿修订版进行编辑。",
  "Unit & position": "单位与位置",
  "Unit for occurrence {value0}": "使用项 {value0} 的单位",
  "Unspecified": "未指定",
  "Unused assignments are corrected directly. Controlled identities are renamed atomically with historical redirects; revisions, configurations, and usage references stay attached.": "未使用的分配可直接更正。受控标识以原子方式重命名并保留历史重定向；修订版、配置和使用引用仍保持关联。",
  "Use product-version root": "使用产品版本根节点",
  "Variant": "变体",
  "Versions": "版本",
  "You do not have company access yet. Open an invitation from a company owner.": "您尚无公司访问权限，请打开公司所有者的邀请。",
  "Your account does not have access to this company.": "您的账户无权访问此公司。",
  "and its selected exact child revisions? The assembly and every child revision must already be released.": "及其选定的确切子项修订版？装配体及所有子项修订版必须已发布。",
  "as": "作为",
  "because the new cover was explicitly numbered as related to the existing one.": "因为新盖板被明确编号为现有盖板的关联零件。",
  "may replace": "可替代",
  "using": "使用",
  "· Expires": "· 到期",
  "Sign in again": "重新登录",
  "Refresh session": "刷新会话",
  "Connection interrupted. Check the saved change before making another edit.": "连接中断。再次编辑前请检查已保存的更改。",
  "The request could not be completed.": "无法完成请求。",
  "Resolve the saved change shown above before making another edit.": "再次编辑前，请先确认已保存更改的结果。",
  "Browser storage is unavailable. Enable it before saving a change.": "浏览器存储不可用，请启用后再保存更改。",
  "No position": "无位置",
  "Not specified.": "未指定。",
  "No description.": "无描述。",
  "Field": "字段",
  "Choose…": "请选择…",
  "Choose": "选择",
  "Complete {field}.": "请填写{field}。",
  "Check the value of {field}.": "请检查{field}的值。",
  "Do not submit another edit until this change is confirmed.": "确认此更改前，请勿提交其他编辑。",
  "CFG1 keeps cover REV1; CFG2 selects cover REV2. A configuration is not a new part number and applies only to assemblies.": "CFG1 保留盖板 REV1；CFG2 选择 REV2。配置不是新零件编号，且仅适用于装配体。",
  "No variant": "无变体",
  "Company created": "已创建公司",
  "Company updated": "已更新公司",
  "Variant code registered": "已注册变体代码",
  "Position code registered": "已注册位置代码",
  "Role changed": "已更改角色",
  "Membership removed": "已移除成员权限",
  "Invitation created": "已创建邀请",
  "Invitation link replaced": "已替换邀请链接",
  "Invitation revoked": "已撤销邀请",
  "Invitation accepted": "已接受邀请",
  "Revision created": "已创建修订版",
  "Revision definition updated": "已更新修订版定义",
  "Revision released": "已发布修订版",
  "Structure occurrence added": "已将零件加入结构",
  "Structure occurrence updated": "已更新零件使用项",
  "Structure occurrence removed": "已从结构移除零件",
  "Configuration created": "已创建配置",
  "Configuration updated": "已更新配置",
  "Configuration released": "已发布配置",
  "Replacement recorded": "已记录替代关系",
  "Replacement withdrawn": "已撤回替代关系",
  "Project created": "已创建项目",
  "Project updated": "已更新项目",
  "Product version created": "已创建产品版本",
  "Product version updated": "已更新产品版本",
  "Part issued": "已分配零件编号",
  "Part details updated": "已更新零件详情",
  "alias-added": "已添加外部编号",
  "alias-edited": "已编辑外部编号",
  "alias-removed": "已移除外部编号",
  "Identity renamed": "已重命名标识",
  "Assignment corrected": "已更正分配",
  "North": "北",
  "South": "南",
  "West": "西",
  "East": "东",
  "Front": "前",
  "Rear": "后",
  "Mid": "中",
  "Top": "上",
  "Bottom": "下",
  "Side": "侧",
  "North / south": "北 / 南",
  "West / east": "西 / 东",
  "Front / rear": "前 / 后",
  "Top / bottom": "上 / 下",
  "Custom": "自定义",
  "Family, not an orderable P/N": "系列，不是可订购的零件编号",
  "Pending": "待处理",
  "Accepted": "已接受",
  "Revoked": "已撤销",
  "Expired": "已过期",
  "Edit revision definition": "编辑修订定义",
  "Release revision?": "发布修订？",
  "Release configuration?": "发布配置？",
  "A complete SHA-256 checksum is required.": "必须提供完整的 SHA-256 校验和。",
  "Add comment": "添加评论",
  "Add file": "添加文件",
  "All": "全部",
  "Applicability": "适用范围",
  "Applicability must refer to a configuration of the owning part.": "适用范围必须引用文档所属零件的配置。",
  "Applicability must refer to a revision of the owning part.": "适用范围必须引用文档所属零件的修订。",
  "Applicability notes": "适用范围备注",
  "Attachment": "附件",
  "Cancel upload": "取消上传",
  "Cancelled": "已取消",
  "Checking file…": "正在检查文件…",
  "Choose Draft or Issued status.": "请选择“草稿”或“已发布”状态。",
  "Choose Source, Rendition or Attachment.": "请选择“源文件”、“呈现版本”或“附件”。",
  "Choose a draft document or production job for this file.": "请为此文件选择文档草稿或生产任务。",
  "Choose a file of this revision.": "请选择此修订的文件。",
  "Choose a registered document type.": "请选择已注册的文档类型。",
  "Choose a supported document owner.": "请选择受支持的文档所属对象。",
  "Choose a valid results page and a positive page size.": "请选择有效的结果页，且每页条数必须为正数。",
  "Choose an issued revision of this document.": "请选择此文档的已发布修订。",
  "Choose the viewed revision of this document.": "请选择当前查看的文档修订。",
  "Choose this company as the document owner.": "请选择此公司作为文档所有者。",
  "Clear applicability references": "清除适用范围引用",
  "Comment": "评论",
  "Comment history": "评论历史",
  "Comment removed": "评论已删除",
  "Copy this revision into a shared editable draft?": "将此修订复制为共享的可编辑草稿？",
  "Create document": "创建文档",
  "Create shared draft": "创建共享草稿",
  "Deleted comments retain their history and cannot be edited.": "已删除评论的历史记录会保留，但无法再编辑。",
  "Discussion": "讨论",
  "Document comment added": "已添加文档评论",
  "Document comment deleted": "已删除文档评论",
  "Document comment edited": "已编辑文档评论",
  "Document created": "文档已创建",
  "Document draft created": "文档草稿已创建",
  "Document draft updated": "文档草稿已更新",
  "Document file": "文档文件",
  "Document file linked": "文件已关联到文档",
  "Document file unlinked": "已解除文件与文档的关联",
  "Document files published": "文档文件已公开",
  "Document files unpublished": "已停止公开文档文件",
  "Document information": "文档信息",
  "Document issued": "文档已发布",
  "Document number": "文档编号",
  "Document reader": "文档阅读器",
  "Document type": "文档类型",
  "Document type registered": "文档类型已注册",
  "Documents": "文档",
  "Download {name}": "下载 {name}",
  "Edit comment": "编辑评论",
  "Edit draft": "编辑草稿",
  "Edit history": "编辑历史",
  "Exact engineering applicability": "精确工程适用范围",
  "Exact revision": "精确修订",
  "File": "文件",
  "File name": "文件名",
  "File purpose": "文件用途",
  "File size must be between 1 byte and 20 GiB.": "文件大小必须介于 1 字节和 20 GiB 之间。",
  "File storage is not configured.": "尚未配置文件存储。",
  "File unavailable": "文件不可用",
  "Files": "文件",
  "Files available to anyone with the public link": "任何拥有公开链接的人均可访问这些文件",
  "Files can only be added to a draft document.": "只能向文档草稿添加文件。",
  "Identifier filter": "标识符筛选",
  "Issue revision": "发布修订",
  "Issue this exact revision? Its metadata and files will become immutable.": "发布此精确修订？其元数据和文件将不可更改。",
  "Issued": "已发布",
  "Issued revisions are immutable. Create a shared draft to make changes.": "已发布修订不可更改。请创建共享草稿以进行修改。",
  "Link at least one verified file before issuing.": "发布前请至少关联一个已验证文件。",
  "New file": "新文件",
  "No comments yet.": "暂无评论。",
  "No files in this revision.": "此修订中没有文件。",
  "No published files.": "没有公开的文件。",
  "No revisions available.": "没有可用的修订。",
  "Only an unfinished upload can be cancelled.": "只能取消尚未完成的上传。",
  "Only issued files can be published.": "只有已发布修订的文件才能公开。",
  "Only length- and SHA-256-verified immutable files can be linked or issued.": "只能关联或发布已验证长度和 SHA-256 校验和的不可变文件。",
  "Open public link": "打开公开链接",
  "Owner kind": "所属对象类型",
  "Page {page} · {count} documents": "第 {page} 页 · {count} 份文档",
  "Part revision": "零件修订",
  "Pause": "暂停",
  "Paused": "已暂停",
  "Preview is not available for this file. Download it instead.": "此文件不支持预览，请下载查看。",
  "Preview unavailable. Download the file to view it.": "预览不可用。请下载文件以查看。",
  "Public description": "公开描述",
  "Public links": "公开链接",
  "Public title": "公开标题",
  "Publication not found.": "未找到公开分享记录。",
  "Publish selected files": "公开选定文件",
  "Published document not found.": "未找到公开的文档。",
  "Published file not found.": "未找到公开的文件。",
  "Register document type": "注册文档类型",
  "Reload revision": "重新加载修订",
  "Remove comment": "删除评论",
  "Remove file": "移除文件",
  "Remove this comment? Its edit history is retained.": "删除此评论？其编辑历史将保留。",
  "Remove this file from the draft? Earlier issued revisions keep their files.": "从草稿中移除此文件？先前已发布修订的文件将保留。",
  "Remove {name}": "移除 {name}",
  "Rendition": "呈现版本",
  "Resume this upload with the recorder who started it.": "请使用发起此上传的记录员身份继续上传。",
  "Resume upload": "继续上传",
  "Revision unavailable": "修订不可用",
  "Revision {number}": "修订 {number}",
  "Revision {number} · {status}": "修订 {number} · {status}",
  "SHA-256": "SHA-256",
  "Search documents": "搜索文档",
  "Select distinct issued files to publish.": "请选择不重复的已发布修订文件以公开分享。",
  "Select files from this exact issued revision.": "请选择此精确的已发布修订中的文件。",
  "Select the same file to resume this upload.": "请选择同一个文件以继续上传。",
  "Source": "源文件",
  "Status": "状态",
  "Stop subsequent access through this public link? Already downloaded copies are not removed.": "停止通过此公开链接的后续访问？已下载的副本不会被删除。",
  "That document revision was not found in this company.": "在此公司中未找到该文档修订。",
  "The configuration must select the exact applicability revision.": "配置必须选用适用范围指定的精确修订。",
  "The document input changed during capture. Retry the same request.": "记录过程中，文档输入已更改。请重试同一请求。",
  "The file upload is not complete.": "文件上传尚未完成。",
  "The issued files no longer match their immutable manifest.": "已发布的文件不再与其不可变清单一致。",
  "The issued manifest failed integrity verification.": "已发布清单未通过完整性验证。",
  "The uploaded file checksum does not match. Cancel this upload and select the original file again.": "上传文件的校验和不匹配。请取消此次上传，并重新选择原始文件。",
  "The uploaded file is unavailable.": "上传的文件不可用。",
  "The verified file must belong to this document.": "已验证文件必须属于此文档。",
  "This comment is already deleted.": "此评论已被删除。",
  "This document already has a shared draft.": "此文档已有共享草稿。",
  "This document numbering sequence is exhausted.": "此文档编号序列已用尽。",
  "This file is not available.": "此文件不可用。",
  "This file is unavailable. Contact the company owner.": "此文件不可用。请联系公司所有者。",
  "This revision changed. Reload it before publishing.": "此修订已更改。公开文件前请重新加载。",
  "This upload cannot be verified.": "无法验证此次上传。",
  "This upload is no longer writable.": "此次上传已不再接受写入。",
  "This upload was not found.": "未找到此次上传。",
  "Title": "标题",
  "Title filter": "标题筛选",
  "Type code": "类型代码",
  "Type name": "类型名称",
  "Unpublish": "停止公开",
  "Unpublished": "已停止公开",
  "Upload file": "上传文件",
  "Uploaded": "已上传",
  "Uploading…": "正在上传…",
  "Use a file name without a path or control characters.": "请使用不含路径或控制字符的文件名。",
  "Use a file name without directory separators.": "请使用不含目录分隔符的文件名。",
  "Use an uppercase alphanumeric type code starting with a letter.": "类型代码须由大写拉丁字母和数字组成，且以字母开头。",
  "Verified": "已验证",
  "Verifying file…": "正在验证文件…",
  "View draft": "查看草稿",
  "file-upload-created": "文件上传已创建",
  "file-verified": "文件已验证",
  "{bytes} bytes": "{bytes} 字节",
  "No matching documents.": "没有匹配的文档。",
  "No documents yet.": "暂无文档。",
  "The revision’s applicability details could not be loaded. Try again.": "无法加载此修订的适用范围详情。请重试。",
  "Comment authors could not be loaded. Try again.": "无法加载评论作者。请重试。",
  "Comment history authors could not be loaded. Try again.": "无法加载评论历史中的修改者。请重试。",
  "Choose a saved search": "选择已保存的搜索",
  "This saved search belongs to another person or collection.": "此保存的搜索属于其他用户或集合。",
  "Choose a saved parts search.": "选择已保存的零件搜索。",
  "Supply document search filters.": "请提供文档搜索筛选条件。",
  "Pages": "页码",
  "{from}–{to} of {total}": "第 {from}–{to} 项，共 {total} 项",
  "Choose lot": "选择批次",
  "Choose material": "选择材料",
  "No matches": "无匹配项",
  "Stock": "库存",
  "Lots": "批次",
  "Materials": "材料",
  "Supplier": "供应商",
  "Material identifier": "材料标识",
  "Specification": "技术规格",
  "Reload latest versions": "重新加载最新版本",
  "Edit material": "编辑材料",
  "Create material revision": "创建材料修订版",
  "Edit material revision": "编辑材料修订版",
  "Release material revision": "发布材料修订版",
  "Create lot": "创建批次",
  "Choose an exact material revision.": "请选择具体的材料修订版。",
  "Lot identifier": "批次标识",
  "Balances": "库存结存",
  "No stock recorded": "尚无库存记录",
  "Genealogy": "批次谱系",
  "No linked lots": "无关联批次",
  "To": "至",
  "Reversed": "已冲销",
  "Movement details": "库存变动详情",
  "Record history": "记录历史",
  "Movements": "库存变动",
  "Movement type": "库存变动类型",
  "No movements recorded": "尚无库存变动记录",
  "Original movement": "原始库存变动",
  "Replaced movement": "已替换的库存变动",
  "Reversal": "冲销",
  "Reverse movement": "冲销库存变动",
  "Record replacement": "记录替代项",
  "Movement warnings unavailable": "库存变动警告不可用",
  "Warnings": "警告",
  "Actual quantity": "实际数量",
  "Location": "存放位置",
  "Disposition": "处置状态",
  "Use balance location": "使用结存所在位置",
  "Wait for the latest balances.": "请等待最新库存结存加载完成。",
  "Choose a lot for every quantity.": "请为每项数量选择批次。",
  "Source {number}": "来源 {number}",
  "Remove source": "移除来源",
  "Add source": "添加来源",
  "Output {number}": "产出 {number}",
  "Remove output": "移除产出",
  "Add output": "添加产出",
  "Destination location": "目标存放位置",
  "Source reference": "来源参考号",
  "Reason": "原因",
  "Reload latest balances": "重新加载最新库存结存",
  "Receipt": "入库",
  "Accept": "验收",
  "Quarantine": "隔离",
  "Transfer": "调拨",
  "Consume": "领用消耗",
  "Scrap": "报废",
  "Split": "拆分",
  "Merge": "合并",
  "MaterialLots": "材料批次",
  "Receipts": "入库记录",
  "Create material": "创建材料",
  "Search lots": "搜索批次",
  "Search materials": "搜索材料",
  "Select a lot": "请选择批次",
  "Select a material": "请选择材料",
  "Supplier reference": "供应商参考号",
  "Supplier lot reference": "供应商批次号",
  "Material created": "已创建材料",
  "Material renamed": "已重命名材料",
  "Material revision created": "已创建材料修订版",
  "Material revision edited": "已编辑材料修订版",
  "Material revision released": "已发布材料修订版",
  "Lot created": "已创建批次",
  "Correction": "更正",
  "Record updated": "已更新记录",
  "All movements": "全部库存变动",
  "Quarantined": "已隔离",
  "Not recorded": "未记录",
  "No matching records.": "无匹配记录。",
  "Page": "页",
  "Evidence warnings": "佐证材料警告",
  "Production": "生产",
  "Create job": "创建生产任务",
  "Routes": "工艺路线",
  "Search jobs": "搜索生产任务",
  "Clear part filter": "清除零件筛选",
  "No jobs found.": "未找到生产任务。",
  "Select a job to review or record actual work.": "请选择任务以查看或记录实际作业。",
  "Change": "更改",
  "Select an exact definition revision.": "请选择具体的定义修订版。",
  "Job identifier": "任务标识",
  "Route input": "输入工艺路线",
  "Document inputs": "输入文件",
  "Select route": "选择工艺路线",
  "Back": "返回",
  "Create route": "创建工艺路线",
  "Create route revision": "创建工艺路线修订版",
  "Choose another route": "选择其他工艺路线",
  "Inspection expected": "需检验",
  "Route name": "工艺路线名称",
  "Operation": "工序",
  "Instructions": "作业说明",
  "Move up": "上移",
  "Move down": "下移",
  "Remove operation": "移除工序",
  "Add operation": "添加工序",
  "Serials": "序列化单件",
  "ProductionOutputs": "生产产出",
  "Operations": "工序",
  "Inspections": "检验",
  "Declarations": "声明",
  "Back to collection": "返回列表",
  "Recorded at": "记录时间",
  "Created": "创建时间",
  "Display columns": "显示列",
  "Import records": "导入记录",
  "Preview records": "预览记录",
  "New preview": "新建预览",
  "Apply valid rows": "应用有效行",
  "Reload preview": "重新加载预览",
  "Row {number}": "第 {number} 行",
  "Applied": "已应用",
  "Apply row": "应用此行",
  "Source name": "来源名称",
  "Record type": "记录类型",
  "Download CSV template": "下载 CSV 模板",
  "CSV file": "CSV 文件",
  "Previous imports": "以往导入",
  "Manual entry": "手动录入",
  "Choose a CSV file.": "请选择 CSV 文件。",
  "The CSV file exceeds the import size limit.": "CSV 文件超过导入大小限制。",
  "Serial number": "序列号",
  "Output source reference": "产出来源参考号",
  "Step": "步骤",
  "Result": "结果",
  "Actual result": "实际结果",
  "Kind": "种类",
  "Value": "值",
  "Exact configuration": "具体配置",
  "Exact route revision": "具体工艺路线修订版",
  "Material definition": "材料定义",
  "Primary definition": "主要定义",
  "Route revision": "工艺路线修订版",
  "Record output": "记录产出",
  "Record operation": "记录工序",
  "Record inspection": "记录检验",
  "Record consumption or component": "记录消耗或组件",
  "Declare output": "声明产出状态",
  "Capture as-built": "记录实制配置",
  "Unnamed record": "未命名记录",
  "Serial": "序列号",
  "None available": "无可用项",
  "The selected job was not found in an editable company.": "在可编辑的公司中未找到所选任务。",
  "Offline job": "离线任务",
  "Download selected job": "下载所选任务",
  "Offline work": "离线作业",
  "Selected job and files saved for offline use.": "所选任务及文件已保存，可供离线使用。",
  "Download": "下载",
  "bytes": "字节",
  "Find material lots": "查找材料批次",
  "Find component parts": "查找组件零件",
  "Correct recorded work": "更正已记录作业",
  "Save correction": "保存更正",
  "Save offline": "离线保存",
  "Wait for evidence to finish saving.": "请等待佐证材料保存完成。",
  "Choose an output with a recorded version.": "请选择有已记录版本的产出。",
  "Reconnect and load current records before saving a correction.": "请重新连接并加载当前记录后再保存更正。",
  "Confirm that this correction uses the current stock version.": "请确认此更正使用当前库存版本。",
  "The original recording is retained. Review current records before submitting a separate correction.": "原始记录会保留。提交单独的更正前，请查看当前记录。",
  "Loading current records": "正在加载当前记录",
  "Current stock": "当前库存",
  "Completed": "已完成",
  "Failed": "失败",
  "Skipped": "已跳过",
  "InProgress": "进行中",
  "Passed": "通过",
  "Inconclusive": "无法判定",
  "I reviewed the stock conflict and authorize this correction against current stock.": "我已审核库存冲突，并授权基于当前库存进行此更正。",
  "Quality": "质量",
  "NotStarted": "未开始",
  "Rejected": "已拒绝",
  "As-built": "实制配置",
  "Evidence file": "佐证文件",
  "Saving evidence locally": "正在本地保存佐证材料",
  "The correction retains the original evidence attachments.": "更正会保留原始佐证附件。",
  "Reconnect to verify recorder access before continuing.": "请重新连接以验证记录人员的权限，然后继续。",
  "Reconnect as the original offline recorder.": "请以最初的离线记录人员身份重新连接。",
  "Offline recording access was revoked. Recorded work is retained.": "离线记录权限已撤销。已记录作业仍然保留。",
  "Reconnect": "重新连接",
  "Loading": "加载中",
  "No offline job is open. Download a selected production job while connected.": "尚未打开离线任务。请在联网时下载所选生产任务。",
  "Selected job": "所选任务",
  "Online": "在线",
  "Offline": "离线",
  "Resume download": "继续下载",
  "Synchronize": "同步",
  "Close offline session": "关闭离线会话",
  "Captured operations": "已保存工序",
  "No route captured": "未保存工艺路线",
  "Recorded inspections": "已记录检验",
  "Outputs": "产出",
  "No outputs recorded": "尚无产出记录",
  "Downloaded files": "已下载文件",
  "Material lots": "材料批次",
  "Record work": "记录作业",
  "Recorded commands": "已记录操作",
  "No local commands recorded": "尚无本地操作记录",
  "Retained original; correction recorded": "已保留原始记录；已记录更正",
  "Retry unchanged": "原样重试",
  "Saved evidence": "已保存佐证材料",
  "Close only after all recorded work and evidence are accepted. Local history remains available.": "请仅在所有作业记录及佐证材料均已被接受后关闭。本地历史记录仍可访问。",
  "Offline storage is unavailable in this browser.": "此浏览器无法使用离线存储。",
  "The offline application could not be downloaded. Try again online.": "无法下载离线应用。请联网后重试。",
  "The offline application is not ready. Reload online and try again.": "离线应用尚未就绪。请联网刷新后重试。",
  "An offline update is waiting. Close other registry tabs and reload online.": "离线更新正在等待。请关闭其他登记系统标签页并联网刷新。",
  "Verified files": "已验证文件",
  "Component part": "组件零件",
  "Component serials": "组件序列化单件",
  "Output": "产出",
  "Reserved serial": "已预留序列化单件",
  "Output lot": "产出批次",
  "Operation order": "工序顺序",
  "Shared run": "共用生产批次",
  "Rework of": "返工对象",
  "Inspection": "检验",
  "Actual": "实际值",
  "Operation attempt": "工序执行尝试",
  "Material lot": "材料批次",
  "Component serial": "组件序列化单件",
  "Actual revision": "实际修订版",
  "Declaration": "声明",
  "Declared state": "声明状态",
  "Amends snapshot": "修正的快照",
  "Attach saved evidence": "附加已保存佐证材料",
  "preparing": "准备中",
  "downloading": "下载中",
  "ready": "已就绪",
  "rejected": "已拒绝",
  "closed": "已关闭",
  "pending": "待处理",
  "sending": "发送中",
  "accepted": "已接受",
  "conflict": "冲突",
  "staged": "已暂存",
  "uploading": "上传中",
  "verified": "已验证",
  "attached": "已附加",
  "Captured inputs": "已保存输入",
  "Captured route": "已保存工艺路线",
  "Planned components": "计划组件",
  "No planned components.": "无计划组件。",
  "No file evidence recorded.": "尚无佐证文件记录。",
  "Evidence files": "佐证文件",
  "Actual outputs": "实际产出",
  "No actual outputs recorded.": "尚无实际产出记录。",
  "Operations and inspections": "工序与检验",
  "Create shared run": "创建共用生产批次",
  "Record rework": "记录返工",
  "No operations or inspections recorded.": "尚无工序或检验记录。",
  "Actual components and lots": "实际组件与批次",
  "Record component or lot": "记录组件或批次",
  "No actual components recorded.": "尚无实际组件记录。",
  "Job documents": "任务文件",
  "Whole job": "整个任务",
  "Actual component": "实际组件",
  "Unserialized output": "未序列化产出",
  "Not declared": "未声明",
  "Declare production": "声明生产状态",
  "Declare quality": "声明质量状态",
  "Amend as-built": "修正实制配置",
  "Declaration history": "声明历史",
  "As-built history": "实制配置历史",
  "Snapshot": "快照",
  "Choose a declaration.": "请选择声明。",
  "As-built snapshot": "实制配置快照",
  "Actual output": "实际产出",
  "No serialized units found.": "未找到序列化单件。",
  "Serialized output": "序列化产出",
  "Clear": "清除",
  "Choose a result.": "请选择结果。",
  "Inspection name": "检验名称",
  "Use shared run": "使用共用生产批次",
  "This job is not part of this shared run.": "此任务不属于该共用生产批次。",
  "Choose another run": "选择其他生产批次",
  "Run identifier": "生产批次标识",
  "Serialized unit": "序列化单件",
  "Select the actual component or lot.": "请选择实际组件或批次。",
  "Serial units": "序列化单件",
  "Allocate serials": "分配序列号",
  "Import serial labels": "导入序列号标识",
  "Void": "作废",
  "Void serial": "作废序列号",
  "Reprint label": "重印标签",
  "Enter positive integer serial numbers.": "请输入正整数序列号。",
  "Number of serials": "序列号数量",
  "Existing serial numbers": "现有序列号",
  "Serial label": "序列号标签",
  "Allow pop-ups to print this label.": "请允许弹出窗口以打印此标签。",
  "Print label": "打印标签",
  "Lot {lot} uses draft material revision {revision}.": "批次 {lot} 使用材料修订版草稿 {revision}。",
  "Consumed quarantined stock: {lot}.": "已消耗隔离库存：{lot}。",
  "Insufficient stock: {lot} at {location} ({disposition}); available {available}, recorded outgoing {outgoing}.": "库存不足：{location} 的 {lot}（{disposition}）；可用 {available}，已记录出库 {outgoing}。",
  "syncing": "同步中",
  "Supply the selected template's values.": "请提供所选模板的值。",
  "Manual intake contains an unknown column.": "手动录入包含未知列。",
  "A manual value is missing or too long.": "手动输入的值缺失或过长。",
  "Supply CSV text.": "请提供 CSV 文本。",
  "Supply CSV text of at most 1 MiB.": "请提供不超过 1 MiB 的 CSV 文本。",
  "CSV text cannot contain null characters.": "CSV 文本不能包含空字符。",
  "CSV exceeds the 1 MiB UTF-8 limit.": "CSV 超过 UTF-8 编码下的 1 MiB 限制。",
  "CSV must contain valid UTF-8 text.": "CSV 必须包含有效的 UTF-8 文本。",
  "The CSV header is missing.": "缺少 CSV 表头。",
  "Every header must be unique.": "每个列标题必须唯一。",
  "The template requires this header, even when its values are optional.": "即使该列的值为可选项，模板仍要求此列标题。",
  "This column is not in the selected template.": "所选模板中没有此列。",
  "CSV contains more than 500 data rows.": "CSV 包含超过 500 行数据。",
  "This row must have exactly the number of fields in the header.": "此行的字段数量必须与表头完全一致。",
  "Malformed CSV quoting or a field exceeds the 16,000-character limit. Correct the source and create a new preview.": "CSV 引号格式错误，或某字段超过 16,000 字符限制。请修正源文件并创建新预览。",
  "A source reference may occur only once in a preview.": "同一来源参考号在预览中只能出现一次。",
  "Supply at least one data row.": "请提供至少一行数据。",
  "This preview uses an older intake contract. Create a new preview.": "此预览使用旧版导入规则。请创建新预览。",
  "The selected row does not match this immutable preview.": "所选行与此不可变预览不匹配。",
  "Correct the CSV errors and create a new preview before applying this row.": "应用此行前，请修正 CSV 错误并创建新预览。",
  "This source row has already been applied with another payload or recorder. It cannot be overwritten.": "此源数据行已由其他记录人员或使用其他数据应用，不能覆盖。",
  "This row no longer meets the intake contract. Create a new preview.": "此行不再符合导入规则。请创建新预览。",
  "Referenced data changed after preview. Review the current data and create a new preview; this row was not rebased.": "引用数据在预览后发生变化。请审核当前数据并创建新预览；此行未自动调整以匹配新数据。",
  "No exact company reference matches this value.": "公司内没有与此值精确匹配的引用。",
  "This reference is ambiguous; select an exact source reference.": "此引用存在歧义；请选择精确的来源参考号。",
  "This material identifier already exists; intake does not overwrite definitions.": "此材料标识已存在；导入不会覆盖定义。",
  "This lot identifier already exists; intake does not overwrite lots.": "此批次标识已存在；导入不会覆盖批次。",
  "Use the exact material revision unit.": "请使用材料修订版的确切单位。",
  "Use the exact authored lot unit; stock is not converted.": "请使用批次原定的确切单位；库存不会换算。",
  "The job must produce the exact selected part.": "任务必须生产所选的确切零件。",
  "This serial is already allocated or imported and cannot be reused.": "此序列号已分配或导入，不能重复使用。",
  "A serialized output is exactly one ea.": "序列化产出的数量必须恰为 1 ea。",
  "A part job cannot declare a material lot output.": "零件生产任务不能声明材料批次产出。",
  "The operation must exist in the job's captured route.": "工序必须存在于任务已保存的工艺路线中。",
  "Select one actual output by its exact source reference.": "请根据精确来源参考号选择一项实际产出。",
  "Use at most {maximum} characters.": "请勿超过 {maximum} 个字符。",
  "A value is required.": "必须提供值。",
  "Use a positive, unpadded integer.": "请使用不带前导零的正整数。",
  "Use a positive decimal quantity, without grouping, with at most six fractional and twelve integer digits.": "请使用不带分组分隔符的正小数数量，最多六位小数和十二位整数。",
  "Use an actual UTC timestamp such as 2026-09-07T12:30:00Z.": "请使用实际 UTC 时间戳，例如 2026-09-07T12:30:00Z。",
  "Choose Accepted or Quarantined.": "请选择 Accepted 或 Quarantined。",
  "Choose Completed, Failed, Skipped or InProgress.": "请选择 Completed、Failed、Skipped 或 InProgress。",
  "Choose Passed, Failed or Inconclusive.": "请选择 Passed、Failed 或 Inconclusive。",
  "An imported serial requires its complete part PIN.": "导入序列号需提供完整零件 PIN。",
  "Choose Production or Quality.": "请选择 Production 或 Quality。",
  "Choose a declaration value belonging to this kind.": "请选择属于此种类的声明值。",
  "This intake preview was not found for this recorder and company.": "未找到属于此记录人员及公司的导入预览。",
  "This preview row was not found.": "未找到此预览行。",
  "Choose a published intake template.": "请选择已发布的导入模板。",
  "Use an actual UTC timestamp.": "请使用实际 UTC 时间戳。",
  "This material identifier already exists.": "此材料标识已存在。",
  "Released or used definitions stay unchanged. Create a new revision.": "已发布或已使用的定义保持不变。请创建新修订版。",
  "This material revision is already released.": "此材料修订版已发布。",
  "Use the exact material revision unit; stock is not converted.": "请使用材料修订版的确切单位；库存不会换算。",
  "This lot identifier already exists.": "此批次标识已存在。",
  "This lot changed. Reload its balances before recording stock.": "此批次已更改。请重新加载结存后再记录库存。",
  "Use the lot's exact authored unit; stock is not converted.": "请使用批次原定的确切单位；库存不会换算。",
  "Reverse the original movement before recording its replacement.": "记录替代项前，请先冲销原始库存变动。",
  "This movement already has a replacement.": "此库存变动已有替代项。",
  "This movement has already been corrected.": "此库存变动已更正。",
  "Use an exact location without surrounding whitespace.": "请使用准确的存放位置，前后勿留空格。",
  "Split and merge require the same exact material revision.": "拆分与合并要求材料修订版完全相同。",
  "Split and merge preserve disposition.": "拆分与合并保持处置状态不变。",
  "Split and merge quantities must match exactly.": "拆分与合并的数量必须完全匹配。",
  "This split or merge would create a cycle in the retained lot genealogy.": "此拆分或合并会使保留的批次谱系形成循环。",
  "Quantity must be positive with at most six decimal places and twelve integer digits.": "数量必须为正数，最多六位小数和十二位整数。",
  "Offline storage is unavailable. No local save was confirmed.": "离线存储不可用。未确认本地保存成功。",
  "Offline recording requires browser storage locking.": "离线记录需要浏览器存储锁支持。",
  "Offline storage could not save the change. Keep the original work and retry.": "离线存储无法保存更改。请保留原始作业并重试。",
  "Offline session not found.": "未找到离线会话。",
  "Resolve the saved change shown above before synchronizing offline work.": "请先解决上方显示的已保存更改，再同步离线作业。",
  "This offline session is not the active recorder.": "此离线会话不是当前记录会话。",
  "Offline file storage is unavailable in this browser.": "此浏览器无法使用离线文件存储。",
  "Offline storage capacity cannot be checked.": "无法检查离线存储容量。",
  "Not enough browser storage for the selected offline files.": "浏览器存储空间不足，无法保存所选离线文件。",
  "Streaming downloads are unavailable.": "流式下载不可用。",
  "Choose one job and distinct offline files.": "请选择一个任务及不重复的离线文件。",
  "Choose distinct material lots and component units for offline use.": "请选择不重复的材料批次和组件单件供离线使用。",
  "Reconnect, resolve the active offline work and explicitly close it before switching recorder or job.": "切换记录人员或任务前，请重新连接、处理当前离线作业并明确关闭会话。",
  "Finish preparation or closing before resolving offline work.": "请先完成准备或关闭操作，再处理离线作业。",
  "Choose an unresolved conflicting or rejected command.": "请选择尚未解决的冲突或被拒绝操作。",
  "This offline session is not ready for new commands.": "此离线会话尚不能记录新操作。",
  "Choose distinct evidence staged in this offline session.": "请选择此离线会话中已暂存且不重复的佐证材料。",
  "Only operation attempts and inspections support staged evidence.": "仅工序执行尝试和检验支持暂存佐证材料。",
  "Upload and verify the referenced offline evidence before synchronizing this command.": "同步此操作前，请上传并验证所引用的离线佐证材料。",
  "Select at most 1000 evidence files.": "最多可选择 1000 个佐证文件。",
  "Finish preparation or closing before synchronizing.": "请先完成准备或关闭操作，再进行同步。",
  "Finish preparation before synchronizing.": "请先完成准备，再进行同步。",
  "The offline command response did not confirm acceptance.": "离线操作响应未确认接受成功。",
  "Upload and attach the staged offline evidence before closing. Local evidence is retained.": "关闭前，请上传并附加暂存的离线佐证材料。本地佐证材料仍会保留。",
  "Resolve all pending, conflicting and rejected work before closing this offline session.": "关闭此离线会话前，请处理所有待处理、冲突和被拒绝的作业。",
  "The server session was closed elsewhere. Review the retained local work.": "服务器会话已在其他位置关闭。请检查保留的本地作业。",
  "The server did not confirm closing this offline session.": "服务器未确认此离线会话已关闭。",
  "This file has not been downloaded and verified for offline use.": "此文件尚未下载并验证，无法离线使用。",
  "This offline session is not ready for new evidence.": "此离线会话尚不能接收新佐证材料。",
  "Choose a nonempty evidence file and filename.": "请选择非空佐证文件并填写文件名。",
  "This evidence has not been staged for offline use.": "此佐证材料尚未暂存供离线使用。",
  "Finish closing before updating evidence.": "请先完成关闭操作，再更新佐证材料。",
  "Offline evidence changed. Read its current state before continuing.": "离线佐证材料已更改。请查看其当前状态后再继续。",
  "Resume the original evidence upload.": "请继续原有的佐证材料上传。",
  "The verified server file does not match the staged evidence.": "已验证的服务器文件与暂存的佐证材料不匹配。",
  "This offline session belongs to another recorder.": "此离线会话属于其他记录人员。",
  "This offline session is closed. Its pending work cannot be submitted here.": "此离线会话已关闭，无法在此提交待处理作业。",
  "This command identity is already bound to different work. Keep the original command and record any correction separately.": "此操作标识已绑定其他作业。请保留原始操作并单独记录更正。",
  "Use a serial reserved for this job before the session was prepared.": "请使用会话准备前已为此任务预留的序列号。",
  "This component unit changed. Keep the recorded work and review the conflict.": "此组件单件已更改。请保留已记录作业并审核冲突。",
  "This component revision changed. Keep the recorded work and review the conflict.": "此组件修订版已更改。请保留已记录作业并审核冲突。",
  "This material lot changed. Keep the recorded work and review the stock conflict before submitting a correction.": "此材料批次已更改。请保留已记录作业，审核库存冲突后再提交更正。",
  "This material revision changed. Keep the recorded work and review the conflict.": "此材料修订版已更改。请保留已记录作业并审核冲突。",
  "The command payload does not match its record type. Keep the original pending work for review.": "操作数据与记录类型不匹配。请保留原始待处理作业以供审核。",
  "Not started": "未开始",
  "In progress": "进行中",
  "Captured part revision was a draft.": "保存的零件修订版当时为草稿。",
  "Captured configuration was a draft.": "保存的配置当时为草稿。",
  "A captured component revision was a draft.": "某个保存的组件修订版当时为草稿。",
  "Captured material revision was a draft.": "保存的材料修订版当时为草稿。",
  "Captured route revision was a draft.": "保存的工艺路线修订版当时为草稿。",
  "A captured document revision was a draft.": "某个保存的文件修订版当时为草稿。",
  "No route was captured.": "未保存工艺路线。",
  "An operation has no completed attempt.": "某道工序没有已完成的执行尝试。",
  "An expected inspection was not recorded.": "未记录预期检验。",
  "The history includes failed operations.": "历史记录中包含失败的工序。",
  "The history includes skipped operations.": "历史记录中包含已跳过的工序。",
  "The history includes failed inspections.": "历史记录中包含未通过的检验。",
  "The history includes inconclusive inspections.": "历史记录中包含无法判定的检验。",
  "No inspection evidence was recorded.": "未记录检验佐证材料。",
  "Planned components have no recorded actuals.": "计划组件没有实际使用记录。",
  "A planned component quantity differs from the recorded actuals.": "某个组件的计划数量与已记录实际数量不同。",
  "Quality has not been declared.": "尚未声明质量状态。",
  "Production has not been declared.": "尚未声明生产状态。",
  "Some actual components are recorded for the whole job, not an individual output.": "部分实际组件记录在整个任务下，而非单项产出下。",
  "Some completed operations have no file evidence.": "部分已完成工序没有佐证文件。",
  "An operation was recorded out of order.": "某道工序未按顺序记录。",
  "The serial label is void.": "序列号标识已作废。",
  "Additional evidence warning recorded.": "已记录额外的佐证材料警告。",
  "Document": "文件",
  "Applies to output": "适用于产出",
  "Earlier lot": "先前批次",
  "From lot": "来自批次",
  "Captured component evidence": "已保存组件佐证材料",
  "Actual genealogy": "实际谱系",
  "Related operation": "相关工序",
  "Shared runs": "共用生产批次",
  "Add job to shared run": "将任务添加到共用生产批次",
  "Actual component type": "实际组件类型",
  "CSV": "CSV",
  "An accepted recording command must confirm this evidence attachment.": "已接受的记录操作必须确认此佐证材料已附加。",
  "Choose a downloaded material lot or component serial.": "请选择已下载的材料批次或组件序列化单件。",
  "Choose a supported evidence update.": "请选择支持的佐证材料更新操作。",
  "Choose a supported offline command and an object payload.": "请选择支持的离线操作，并提供对象格式的数据。",
  "Choose the output receiving this component.": "请选择接收此组件的产出。",
  "Evidence file references must be a list of server file IDs.": "佐证文件引用必须是服务器文件标识列表。",
  "Evidence upload failed.": "佐证材料上传失败。",
  "Offline payloads must contain only JSON values.": "离线操作数据只能包含 JSON 值。",
  "Online registry": "在线登记系统",
  "Provide a corrected command payload object.": "请提供对象格式的更正操作数据。",
  "Provide the evidence upload error.": "请提供佐证材料上传错误。",
  "Reconnect to verify recorder access before synchronizing.": "请重新连接以验证记录人员的权限，然后同步。",
  "The offline bundle is missing selected material lots or component units.": "离线数据包缺少所选材料批次或组件单件。",
  "The offline file SHA-256 does not match its manifest.": "离线文件的 SHA-256 与其清单不匹配。",
  "The offline file URL does not match its session.": "离线文件 URL 与其会话不匹配。",
  "The offline file length does not match its manifest.": "离线文件大小与其清单不匹配。",
  "The offline file manifest is invalid.": "离线文件清单无效。",
  "The offline manifest does not match the selected files.": "离线清单与所选文件不匹配。",
  "The offline session does not belong to this recorder and job.": "离线会话不属于此记录人员和任务。",
  "The prepared offline bundle does not match this recorder and job.": "准备的离线数据包与此记录人员和任务不匹配。",
  "The retained correction chain is incomplete.": "保留的更正链不完整。",
  "The retained correction chain is invalid.": "保留的更正链无效。",
  "The selected job changed. Open its download choices again.": "所选任务已更改。请重新打开其下载选项。",
  "The selected offline file could not be downloaded.": "无法下载所选离线文件。",
  "The staged evidence failed SHA-256 verification.": "暂存的佐证材料未通过 SHA-256 验证。",
  "The stored offline evidence failed SHA-256 verification.": "已存储的离线佐证材料未通过 SHA-256 验证。",
  "The stored offline file failed SHA-256 verification.": "已存储的离线文件未通过 SHA-256 验证。",
  "This offline session is closed.": "此离线会话已关闭。",
  "This offline session is closed. Pending work is retained.": "此离线会话已关闭。待处理作业仍然保留。",
  "Agent": "智能体",
  "Agents": "智能体",
  "Member": "成员",
  "Agent name": "智能体名称",
  "Agent reference": "智能体引用",
  "Connected applications": "已连接的应用",
  "Connection address": "连接地址",
  "MCP endpoint": "MCP 端点",
  "New agent": "新建智能体",
  "Create agent": "创建智能体",
  "Manage": "管理",
  "Review transfer": "查看管理权转移",
  "Management transfer awaiting your response": "管理权转移正在等待您的答复",
  "Management transfer pending": "管理权转移待处理",
  "No connected applications.": "暂无已连接的应用。",
  "No agents yet.": "暂无智能体。",
  "Last used {date}": "上次使用：{date}",
  "Disconnect": "断开连接",
  "Disconnect {name}?": "断开与 {name} 的连接？",
  "This application will lose access through this connection.": "此应用将失去通过该连接获得的访问权限。",
  "Manage {name}?": "管理 {name}？",
  "Accept management": "接受管理权",
  "Decline transfer": "拒绝转移",
  "Accepting management revokes the existing credentials. Create new credentials before running this agent again.": "接受管理权会撤销现有凭据。再次运行此智能体前，请创建新凭据。",
  "Disabled": "已停用",
  "Enable agent": "启用智能体",
  "Disable agent": "停用智能体",
  "Enable {name}?": "启用 {name}？",
  "Disable {name}?": "停用 {name}？",
  "Rename": "重命名",
  "Rename agent": "重命名智能体",
  "Transfer management": "转移管理权",
  "Cancel transfer": "取消转移",
  "Request transfer": "请求转移",
  "New manager’s Google account email": "新管理人的 Google 账号邮箱",
  "Share agent reference": "分享智能体引用",
  "Company access": "公司访问权限",
  "No company access. A company owner can add this agent in Members.": "暂无公司访问权限。公司所有者可以在“成员”中添加此智能体。",
  "Credentials": "凭据",
  "New credential": "新建凭据",
  "Create credential": "创建凭据",
  "Credential name": "凭据名称",
  "No credentials yet.": "暂无凭据。",
  "Rotate secret": "更换密钥",
  "Rotate {name}?": "更换 {name} 的密钥？",
  "Revoke {name}?": "撤销 {name}？",
  "Create new credentials after enabling this agent.": "启用此智能体后，请创建新凭据。",
  "This revokes its credentials and stops access in every company.": "这将撤销其凭据并停止其对所有公司的访问。",
  "Existing access tokens issued with this credential will stop working.": "使用此凭据签发的现有访问令牌将失效。",
  "Connection credentials": "连接凭据",
  "Client ID": "客户端 ID",
  "Client secret": "客户端密钥",
  "The secret is shown only once. Save it in your agent’s credential storage.": "密钥仅显示一次。请将其保存到智能体的凭据存储中。",
  "The credential was created, but its secret cannot be shown again. Rotate the secret to replace it.": "凭据已创建，但密钥无法再次显示。请更换密钥。",
  "Copy {value}": "复制{value}",
  "Copy was unavailable. Select the value and copy it manually.": "无法自动复制。请选择该值并手动复制。",
  "Add agent": "添加智能体",
  "Choose a valid agent reference.": "请输入有效的智能体引用。",
  "Managed by {name}": "管理人：{name}",
  "Connect application": "连接应用",
  "Allow connection": "允许连接",
  "Redirect address": "重定向地址",
  "This application can use your current company roles. Access follows changes to your memberships.": "此应用可以使用您当前的公司角色权限。访问权限将随您的成员资格变化而变化。",
  "Agent created": "智能体已创建",
  "Agent updated": "智能体已更新",
  "Agent disabled": "智能体已停用",
  "Credential created": "凭据已创建",
  "Credential rotated": "凭据已更换",
  "Credential revoked": "凭据已撤销",
  "Transfer requested": "已请求转移",
  "Transfer cancelled": "转移已取消",
  "Transfer accepted": "转移已接受",
  "Active agent not found.": "未找到可用的智能体。",
  "Agent not found.": "未找到智能体。",
  "Managed agent not found.": "未找到您管理的智能体。",
  "Credential not found.": "未找到凭据。",
  "Connection not found.": "未找到连接。",
  "Transfer not found.": "未找到转移请求。",
  "This transfer has expired.": "此转移请求已过期。",
  "Choose another manager.": "请选择其他管理人。",
  "The new manager must sign in to the registry first.": "新管理人必须先登录注册系统。",
  "A human account manages agent credentials.": "智能体凭据由个人账号管理。",
  "Enable the agent before creating credentials.": "请先启用智能体，再创建凭据。",
  "Create a new credential after revocation.": "撤销后，请创建新凭据。",
  "This agent is already a member.": "此智能体已是成员。",
  "Another owner must accept membership before disabling the last owner.": "停用最后一位所有者之前，必须有另一位所有者接受成员资格。",
  "Application not found.": "未找到应用。",
  "Users": "Users",
  "Global directory": "Global directory",
  "Search people by name or email": "Search people by name or email",
  "Search users": "Search users",
  "All roles": "All roles",
  "All users": "All users",
  "Administrators": "Administrators",
  "Name / Email": "Name / Email",
  "Web-app role": "Web-app role",
  "Direct companies": "Direct companies",
  "Effective access": "Effective access",
  "Administrator": "Administrator",
  "User": "User",
  "No company access": "No company access",
  "{value0} companies": "{value0} companies",
  "{value0} of {value1} users": "{value0} of {value1} users",
  "No users match these filters.": "No users match these filters.",
  "Grant company access": "Grant company access",
  "No direct company access.": "No direct company access.",
  "Administrator · all companies": "Administrator · all companies",
  "Remove administrator": "Remove administrator",
  "Make administrator": "Make administrator",
  "Remove administrator?": "Remove administrator?",
  "Make administrator?": "Make administrator?",
  "This removes inherited access to every company. Direct memberships remain.": "This removes inherited access to every company. Direct memberships remain.",
  "This gives the user access to every company and the ability to manage users.": "This gives the user access to every company and the ability to manage users.",
  "Remove access?": "Remove access?",
  "Remove access to {value0}": "Remove access to {value0}",
  "Remove direct access to {value0}.": "Remove direct access to {value0}.",
  "Role for {value0}": "Role for {value0}",
  "Company role": "Company role",
  "Grant access": "Grant access",
  "Only web-app administrators can manage the user directory.": "Only web-app administrators can manage the user directory.",
  "Common parts": "共用零件",
  "Common": "共用",
  "Add part to {value0}": "向{value0}添加零件",
  "Assembly actions": "装配操作",
  "Create symmetry": "创建对称",
  "Variant created.": "变体已创建。",
  "Symmetry family updated.": "对称族已更新。",
  "Document categories": "文档类别",
  "Document category": "文档类别",
  "Add category": "添加类别",
  "Edit category": "编辑类别",
  "Edit category {name}": "编辑类别 {name}",
  "Category added.": "类别已添加。",
  "Category saved.": "类别已保存。",
  "Category name": "类别名称",
  "Category code": "类别代码",
  "App default": "应用预设",
  "Archived": "已归档",
  "Show archived categories": "显示已归档类别",
  "No categories available.": "没有可用类别。",
  "Reload": "重新加载",
  "Only company owners and editors can manage document categories.": "只有公司所有者和编辑者可以管理文档类别。",
  "Existing categories share these codes: {codes}. Their records remain separate.": "现有类别共用以下代码：{codes}。各记录仍保持独立。",
  "Upload document": "上传文档",
  "Apply to selected": "应用到所选文件",
  "Back to files": "返回文件列表",
  "Browser storage is unavailable. Keep this window open to retain your edits.": "浏览器存储不可用。请保持此窗口打开，以保留您的修改。",
  "Category for {name}": "{name} 的类别",
  "Check the saved upload change before continuing.": "请先检查已保存的上传修改，再继续。",
  "Choose a matching document": "选择匹配的文档",
  "Choose which document should receive this revision.": "请选择要接收此修订版的文档。",
  "Create a separate document": "创建独立文档",
  "Detected from": "识别依据",
  "Drag and drop files here": "将文件拖放到此处",
  "Edit selected files": "编辑所选文件",
  "Edit {count} selected files": "编辑已选的 {count} 个文件",
  "File details and applicability": "文件详情和适用范围",
  "File preview": "文件预览",
  "File size": "文件大小",
  "Filename": "文件名",
  "Keep current": "保持当前值",
  "Matching document for {name}": "{name} 的匹配文档",
  "New document": "新文档",
  "New revision of {identifier}": "{identifier} 的新修订版",
  "Next file": "下一个文件",
  "Not specified": "未指定",
  "Preview unavailable for this file format.": "此文件格式不支持预览。",
  "Preview {name}": "预览 {name}",
  "Previous file": "上一个文件",
  "Reading file details…": "正在读取文件详情…",
  "Recover saved upload": "恢复已保存的上传",
  "Select a file to preview.": "请选择要预览的文件。",
  "Select all files": "选择所有文件",
  "Select files": "选择文件",
  "Select files to upload.": "请选择要上传的文件。",
  "Select the original file to preview or resume.": "请选择原始文件以预览或继续上传。",
  "Select the original file to resume.": "请选择原始文件以继续上传。",
  "Select {name}": "选择 {name}",
  "Title for {name}": "{name} 的标题",
  "Title pattern": "标题模板",
  "Uploading {name}": "正在上传 {name}",
  "Use {name} for the current title and {n} for a sequence number.": "用 {name} 表示当前标题，用 {n} 表示序号。",
  "{count} files": "{count} 个文件",
  "{count} selected": "已选 {count} 个",
  "{done} of {total} uploaded": "已上传 {done} / {total}",
  "Add files": "添加文件",
  "Retry unfinished uploads": "重试未完成的上传",
  "Drawing": "图纸",
  "Assembly drawing": "装配图",
  "Production drawing": "生产图纸",
  "Bill of materials": "物料清单",
  "Work instruction": "作业指导书",
  "Schematic": "原理图",
  "Wiring diagram": "接线图",
  "Layout": "布局图",
  "3D model": "三维模型",
  "Test procedure": "测试程序",
  "Test report": "测试报告",
  "Inspection plan": "检验计划",
  "Inspection report": "检验报告",
  "Certificate": "证书",
  "Material datasheet": "材料数据表",
  "Calculation": "计算书",
  "Requirements": "需求",
  "Design report": "设计报告",
  "Assembly instruction": "装配说明",
  "Manufacturing process": "制造工艺",
  "Quality plan": "质量计划",
  "Change notice": "变更通知",
  "Manual": "手册",
  "Upload": "上传",
  "Ready": "就绪",
  "Needs attention": "需要处理",
  "Retained": "已保留",
  "manual": "手动修改",
  "filename": "文件名",
  "embedded metadata": "内嵌元数据",
  "filename fallback": "文件名；通用类别",
  "Embedded metadata": "内嵌元数据",
  "Embedded title": "内嵌标题",
  "File selection key": "文件选择标识",
  "Media type": "媒体类型",
  "Document category added": "已添加文档类别",
  "Document category archived": "已归档文档类别",
  "Document category updated": "已更新文档类别",
  "Document upload batch created": "已创建文档上传批次",
  "Document draft retained": "已保留文档草稿",
  "Document upload saved": "已保存上传的文档",
  "Add a Company or Project category.": "请添加公司或项目类别。",
  "Choose a category available in this document context.": "请选择此文档上下文中可用的类别。",
  "Choose a project only for a Project category.": "只有项目类别需要选择项目。",
  "Choose the project that owns this document context.": "请选择此文档上下文所属的项目。",
  "This category code already exists in this scope or an inherited scope. Choose another code.": "当前范围或继承范围中已存在此类别代码。请选择其他代码。",
  "This category is archived. Choose an available category.": "此类别已归档。请选择可用的类别。",
  "This editable category was not found in this company.": "在此公司中未找到此可编辑类别。",
  "Use an uppercase alphanumeric category code starting with a letter.": "类别代码只能包含大写英文字母和数字，且必须以字母开头。",
  "A saved document file cannot be removed from its upload batch.": "无法从上传批次中移除已保存的文档文件。",
  "A selected file key is already in this batch.": "所选文件的标识已存在于此批次中。",
  "Choose a document category.": "请选择文档类别。",
  "Choose a row in this upload batch.": "请选择此上传批次中的一行。",
  "Choose an available document category.": "请选择可用的文档类别。",
  "Choose between 1 and 1000 files.": "请选择 1 至 1000 个文件。",
  "Choose distinct upload rows to edit.": "请选择不同的上传行进行编辑。",
  "Choose either an existing document or a new document.": "请选择现有文档或新文档。",
  "Resume this batch with the recorder who started it.": "请使用启动此批次的记录者账户继续操作。",
  "Several documents match this file. Choose the intended document or create a separate document.": "此文件匹配多个文档。请选择目标文档或创建独立文档。",
  "The selected document no longer matches this owner, category and title. Review the row again.": "所选文档不再与此所有者、类别和标题匹配。请重新检查此行。",
  "This document has an unfinished upload. Finish or cancel it before retrying this row.": "此文档有未完成的上传。请先完成或取消上传，再重试此行。",
  "This upload batch was cancelled.": "此上传批次已取消。",
  "This upload row is already saved or cancelled.": "此上传行已保存或取消。",
  "Upload and verify this file before saving the document.": "请先上传并验证此文件，再保存文档。",
  "Select the original file for this upload row.": "请为此上传行选择原始文件。",
  "This row already has a different upload. Cancel that upload before replacing it.": "此行已有另一个上传。请先取消该上传再替换。",
  "Preview will be available after upload.": "上传后可预览。",
  "existing document": "现有文档",
  "file extension": "文件扩展名",
  "More": "更多",
  "Edit quantity for {value0}": "编辑 {value0} 的数量",
  "This structure cannot contain itself.": "此结构不能包含自身。"
}
